import { Link } from 'react-router-dom';
import './Hero.css';

const STEPS = [
  { n: '1', label: 'Choose scrap type' },
  { n: '2', label: 'Select date' },
  { n: '3', label: 'We collect & recycle' },
];

function ClockIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 8v4.2l2.8 1.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="hero-inner">
        <div className="hero-copy">
          <h1 id="hero-heading">
            Fast &amp; Reliable Scrap Metal Removal Services
          </h1>
          <p className="hero-lead">
            Professional scrap collection for homes, builders, and businesses across the UK.
            Licensed carriers, fair weights, and a full audit trail from pickup to recycling.
          </p>

          <div className="hero-ctas">
            <Link className="btn btn-primary" to="/post-scrap">
              Post Scrap <span aria-hidden="true">&gt;</span>
            </Link>
            <Link className="btn btn-secondary" to="/become-a-collector">
              Become a Collector
            </Link>
          </div>

          <div className="how-it-works">
            <div className="how-label">
              <ClockIcon />
              <span>How it works</span>
            </div>
            <ol className="how-steps">
              {STEPS.map((step) => (
                <li key={step.n}>
                  <span className="how-num">{step.n}</span>
                  <span className="how-text">{step.label}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>

      <Link className="contact-fab" to="/post-scrap">
        Post Scrap
      </Link>
    </section>
  );
}
